import {getCsrfToken} from '../auth/authApi'
import type {PlanningManualAdjustment,PlanningSnapshot} from './types'
import {apiFetch} from '../../shared/http/apiFetch'
const base='/api/v1/planning'
export async function getPlanningSchedule():Promise<PlanningSnapshot>{
  const response=await apiFetch(`${base}/schedule`,{credentials:'include',cache:'no-store'})
  const payload=await response.json().catch(()=>null) as PlanningSnapshot|{code?:string}|null
  if(!response.ok)throw new Error(payload&&'code'in payload&&payload.code?payload.code:'planning.loadError')
  return payload as PlanningSnapshot
}
export async function replanAll():Promise<PlanningSnapshot>{
  const response=await apiFetch(`${base}/replan`,{method:'POST',credentials:'include',
    headers:{'X-CSRF-TOKEN':await getCsrfToken()}})
  const payload=await response.json().catch(()=>null) as {code?:string;snapshot?:PlanningSnapshot}|null
  if(!response.ok)throw new Error(payload?.code??'planning.loadError')
  if(!payload?.snapshot)throw new Error('planning.loadError')
  return payload.snapshot
}
export async function calculatePlanning(start:string,days:number,apply=false,
  manualAdjustments:PlanningManualAdjustment[]=[],expectedPublicationId?:string|null,
  direction:'Forward'|'Backward'|'Hybrid'='Forward',respectMaterialAvailability=true):Promise<PlanningSnapshot>{
  const horizonStartUtc=start.includes('T')?start:`${start}T00:00:00Z`
  const response=await apiFetch(`${base}/${apply?'apply':'preview'}`,{method:'POST',credentials:'include',
    headers:{'Content-Type':'application/json',...(apply?{'X-CSRF-TOKEN':await getCsrfToken()}:{})},
    body:JSON.stringify({horizonStartUtc,horizonDays:days,manualAdjustments,
      expectedPublicationId:expectedPublicationId??null,
      enforcePublicationMatch:expectedPublicationId!==undefined,direction,
      respectMaterialAvailability})})
  const payload=await response.json().catch(()=>null) as (PlanningSnapshot|{code?:string;snapshot?:PlanningSnapshot})|null
  if(!response.ok)throw new Error(payload&&'code'in payload&&payload.code?payload.code:'planning.loadError')
  if(apply&&payload&&'snapshot'in payload&&payload.snapshot)return payload.snapshot
  return payload as PlanningSnapshot
}
export async function createQuickMaintenanceStop(body:{resourceId:string;title:string;description:string;type:'Corrective'|'Preventive'|'Predictive'|'Inspection';priority:'Low'|'Normal'|'High'|'Urgent';startAtUtc:string;endAtUtc:string}){
  const response=await apiFetch('/api/v1/maintenance/quick-stops',{method:'POST',credentials:'include',headers:{'Content-Type':'application/json','X-CSRF-TOKEN':await getCsrfToken()},body:JSON.stringify(body)})
  const payload=await response.json().catch(()=>null)as{code?:string;workOrderId?:string;interruptedOperations?:number}|null
  if(!response.ok)throw new Error(payload?.code??'maintenance.actionError')
  return {workOrderId:payload?.workOrderId??null,interruptedOperations:payload?.interruptedOperations??0}
}
export async function setOperationFixed(operationId:string,isFixed:boolean):Promise<PlanningSnapshot>{
  const response=await apiFetch(`${base}/operations/${operationId}/fixed`,{method:'PUT',credentials:'include',
    headers:{'Content-Type':'application/json','X-CSRF-TOKEN':await getCsrfToken()},
    body:JSON.stringify({isFixed})})
  const payload=await response.json().catch(()=>null) as {code?:string;snapshot?:PlanningSnapshot}|null
  if(!response.ok||!payload?.snapshot)throw new Error(payload?.code??'planning.loadError')
  return payload.snapshot
}
export async function previewMaintenanceReplan():Promise<PlanningSnapshot>{
  const response=await apiFetch('/api/v1/maintenance/replan-preview',{method:'POST',credentials:'include',headers:{'X-CSRF-TOKEN':await getCsrfToken()}})
  const payload=await response.json().catch(()=>null)as{code?:string;snapshot?:PlanningSnapshot}|null
  if(!response.ok||!payload?.snapshot)throw new Error(payload?.code??'planning.loadError')
  return payload.snapshot
}
export async function replanMaintenance():Promise<PlanningSnapshot>{
  const response=await apiFetch('/api/v1/maintenance/replan',{method:'POST',credentials:'include',headers:{'X-CSRF-TOKEN':await getCsrfToken()}})
  const payload=await response.json().catch(()=>null)as{code?:string;snapshot?:PlanningSnapshot}|null
  if(!response.ok||!payload?.snapshot)throw new Error(payload?.code??'planning.loadError')
  return payload.snapshot
}
